export default __webpack_public_path__ + "static/media/add-extensions-icon.11fcdfe8.svg";